import { useMemo } from "react";
import { HeaderMenuContext } from "../header-menu/HeaderMenuContext";
import { HeaderCollection, MenuItem } from "../header-menu/HeaderMenuTypes";
import HamburgerMenuItem from "./HamburgerMenuItem";

interface HamburgerMenuProps {
  menu: MenuItem[];
  headerCollections?: HeaderCollection[];
}

export const HamburgerMenuConfig = {
  key: "hamburger-menu",
  component: HamburgerMenu,
};

export default function HamburgerMenu({
  menu,
  headerCollections,
}: HamburgerMenuProps) {
  const headerMenuContextValue = useMemo(
    () => ({ headerCollections: headerCollections || [] }),
    [headerCollections]
  );

  return (
    <HeaderMenuContext.Provider value={headerMenuContextValue}>
      <nav
        className="
          xflex xflex-col xitems-start
          xgap-2
          xpx-6
      "
      >
        {menu.map((item, index) => (
          <HamburgerMenuItem key={item.title} item={item} itemIndex={index} />
        ))}
      </nav>
    </HeaderMenuContext.Provider>
  );
}
